import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { TabsetComponent } from 'ngx-bootstrap/tabs';

import { Group } from '../../../Models/group';
import { Profile } from '../../../Models/profile';
import { AdminService } from '../../../services/admin.service';
import { Observable, Subject } from 'rxjs';
import { GlobalVariableGroup } from '../../../Models/globalVariableGroup';
import { User } from '../../../Models/user';
import { take } from 'rxjs/operators';
import {until} from 'selenium-webdriver';
import elementTextContains = until.elementTextContains;
import {GenericModalService} from '../../../services/generic-modal.service';
import {CustomValidator} from '../../../services/custom-validator';
import {GlobalVariableService} from '../../../services/configuration/global-variable.service';

declare var $: any;

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.css', '../../../styles/modals.css']
})

export class UserModalComponent implements OnInit {

  @Input() modalTitle: string;
  @ViewChild('userTabs', { static: false }) userTabs: TabsetComponent;

  itemSaved: Subject<boolean>;

  availableGroups: Group[];
  dmSelectedGroups = [];
  selectedGroups = [];
  availableProfiles: Observable<Profile[]>;
  availableGVGroups: Observable<GlobalVariableGroup[]>;

  userForm: FormGroup;
  objId: number;
  objMessage: string;
  submitted = false;
  submitClick = false;
  oldUserData: User;
  userParam: UserParam;
  error = '';

  get formData() { return this.userForm.controls; }

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private admService: AdminService,
    private globalVariableService: GlobalVariableService
  ) { }

  ngOnInit() {
    this.admService.loadGroupList()
      .subscribe(result => { this.availableGroups = result
        .filter((group) => {
          return group.enabled;
        });
        if (this.objId !== 0) {
          this.onEditUser();
        }
      },
      error => {
        let err = error;
        if (error.indexOf('401') !== -1) {
          err = 'Erro: Sessão expirada.';
        }
        this.error = err;
        console.error(error);
      }
      );
    this.createForm();
    this.availableProfiles = this.admService.loadProfiles();
    this.availableGVGroups = this.admService.loadGlobalVariablesGroups();
    this.itemSaved = new Subject();
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  onSave() {
    this.submitted = false;
    this.error = '';
    this.submitClick = true;

    if (this.formData.globalVariableGroupId.value !== 0) {
      this.globalVariableService.getGlobalVariableGroup(this.formData.globalVariableGroupId.value).subscribe(
        res => {
          if (res !== null) {
            this.saveUser();
          } else {
            this.availableGVGroups = this.admService.loadGlobalVariablesGroups();
            this.userForm.patchValue({ globalVariableGroupId: 0 });
            this.error = 'O grupo de variáveis globais foi excluído por outro usuário. Se necessário, selecione um novo grupo';
            this.submitClick = false;
          }
        }
      );
    } else {
      this.saveUser();
    }
  }

  saveUser() {
    const user = this.userForm.getRawValue();
    user.groups = this.availableGroups.filter(item => {
      return (this.selectedGroups.indexOf(item.groupId) > -1);
    });
    this.createUserParam(this.objMessage, this.objId, user, this.oldUserData);
    this.admService.saveUser(this.userParam)
      .pipe(take(1))
      .subscribe(resp => {
          this.submitted = true;
          this.itemSaved.next(true);
          setTimeout(() => {
            this.submitted = false;
            this.bsModalRef.hide();
          }, 2000);
        },
        error => {
          let err = error;
          if (error.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.error = err;
          this.submitClick = false;
        });
  }

  createForm() {
    this.userForm = this.formBuilder.group({
      userId: { value: 0, disabled: true },
      logon: [ '', Validators.compose( [ Validators.required, Validators.maxLength(100) ]) ],
      firstName: ['', Validators.maxLength(100)],
      lastName: ['', Validators.maxLength(100)],
      profileId: [0, this.validateProfile],
      globalVariableGroupId: [0],
      enabled: [true],
      isLdap: [false],
      isSystemUser: [false],
      email: [null, Validators.compose( [Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'), Validators.maxLength(255)] )],
      emailRetype: [null, Validators.compose( [
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'), Validators.maxLength(255)] ) ],
      crivoUser: [''],
      groups: [
        []
      ],
      crivoPassword: [''],
      crivoPasswordRetype: [''],
      passwordHash: ['', Validators.required],
      passwordRetype: ['', Validators.required ]
    }, {validators: [
      CustomValidator.validatePassword('passwordHash', 'passwordRetype'),
      CustomValidator.validatePassword('crivoPassword', 'crivoPasswordRetype' ),
      this.validateEmail('email', 'emailRetype')]});
  }

  validateProfile(input: FormControl) {
    return input.value === 0 ? { emptyProfile: true } : null;
  }

  validateEmail(email: string, confirmEmail: string) {
    return (formGroup: FormGroup) => {
      const emailControl = formGroup.controls[email];
      const confirmEmailControl = formGroup.controls[confirmEmail];
      if (!emailControl || !confirmEmailControl) {
        return null;
      }
      if (confirmEmailControl.errors && !confirmEmailControl.errors.emailMismatch) {
        return null;
      }
      if (emailControl.value !== confirmEmailControl.value) {
        confirmEmailControl.setErrors({ emailMismatch: true });
      } else {
        confirmEmailControl.setErrors(null);
      }
    };
  }

  onEditUser() {
    this.createUserParam(this.objMessage, this.objId);
    this.admService.loadUserById(this.userParam)
      .subscribe(result => {
        if (result) {
          this.userForm.controls.logon.disable();

          // remover obrigatoriedade dos campos de senha quando está no modo edição.
          this.removeValidator('passwordHash');
          this.removeValidator('passwordRetype');

          this.dmSelectedGroups = result.groups.map(m => m.groupId);
          this.selectedGroups = this.dmSelectedGroups;
          // console.log(options);

          this.userForm.patchValue({
            userId: result.userId,
            logon: result.logon,
            firstName: result.firstName,
            lastName: result.lastName,
            profileId: result.profileId,
            globalVariableGroupId: result.globalVariableGroupId,
            enabled: result.enabled,
            isLdap: result.isLdap,
            isSystemUser: result.isSystemUser,
            email: result.email,
            emailRetype: result.email,
            crivoUser: result.crivoUser,
          });
          this.oldUserData = Object.assign({}, result) as User;
        }
      }, error1 => {
        console.error(error1);
      });
  }

  removeValidator(path: string) {
    this.userForm.get(path).clearValidators();
    this.userForm.get(path).updateValueAndValidity();
  }

  private createUserParam(userLogon: string = null, userId: number, user: User = null, oldUser: User = null) {
    this.userParam = {
      userLogon: userLogon,
      userId: userId,
      user: user,
      oldUser: oldUser
    };
  }

  onSelectAll(availableItems: any[], path: string, formGroup: FormGroup) {
    const selected = availableItems.map(item => item.groupId);
    formGroup.get(path).patchValue(selected);
  }

  onClearAll(path: string, formGroup: FormGroup) {
    formGroup.get(path).patchValue([]);
  }

  getSelectedGroups(element) {
    this.selectedGroups = element;
  }

}

export class UserParam {
  userLogon: string;
  userId: number;
  user: User;
  oldUser: User;
}
